import React, { useEffect } from 'react';

import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import ActionPlanDashboard from './dashboard';
import ActionPlanSettings from './settings';

const ActionPlan = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userType = localStorage.getItem('userType');
  const hasSettingsAccess = userType === 'General Manager' || userType === 'Super Admin';

  useEffect(() => {
    if (location.pathname === '/action-plan') {
      navigate('/action-plan/dashboard', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <Routes>
      <Route path="dashboard" element={<ActionPlanDashboard />} />
      <Route
        path="settings"
        element={
          hasSettingsAccess ? <ActionPlanSettings /> : <Navigate to="/action-plan/dashboard" />
        }
      />
      <Route path="*" element={<Navigate to="/action-plan/dashboard" replace />} />
    </Routes>
  );
};

export default ActionPlan;
